module.exports = __webpack_public_path__ + "img/img_xuexi.ed66ebb1.png";